/**
 * Keeps the URI subfield (conventionally `$1`) in step with a sibling `$a`
 * identifier, using the URI subfield's own `uriTemplate` (e.g.
 * `"https://isni.org/isni/{id}"`). Pure client-side string templating, no
 * network call.
 *
 * - CZNA-196: an empty `$1` is filled from `$a`.
 * - CZNA-1467: the URI is only another spelling of the identifier, so `$1`
 *   follows `$a` — emptying `$a` empties `$1` (otherwise the field is saved as
 *   a link with no identifier), changing `$a` rewrites `$1`. A `$1` that
 *   already points at the current identifier (`…/<id>`, e.g. a URI picked
 *   through the online lookup, whose host may differ from the template) is
 *   kept. Groups without a `uriTemplate` (LCNAF, DNB, "other identifier")
 *   never reach this, so their manual `$1` is left alone.
 *
 * Shared between the plain-input renderer (`DynamicFieldPanel`) and
 * `ExternalIdentifierLookupSubfield` (CZNA-367) — a cataloguer who types or
 * pastes an identifier by hand, rather than using the online lookup picker,
 * gets the same sibling-fill either way. Called on `$a` blur and on its clear
 * button.
 */
var fillUriFromIdentifier = function (aValue, siblingSubfields, pathPrefix, getValues, setValue) {
    var uriSubfield = siblingSubfields.find(function (s) { return s.code !== 'a' && !!s.uriTemplate; });
    if (!uriSubfield) {
        return;
    }
    // Deep RHF paths built from config (field tag/code) are not statically
    // resolvable — cast via unknown, matching the project's established pattern
    // for dynamic paths (see `watchAny` in DynamicFieldPanel).
    var uriPath = "".concat(pathPrefix, ".").concat(uriSubfield.code, ".value");
    var getValuesAny = getValues;
    var existingUri = (getValuesAny(uriPath) || '').trim();
    var id = (aValue || '').trim();
    if (!id) {
        if (existingUri) {
            setValue(uriPath, '', { shouldDirty: true });
        }
        return;
    }
    var derivedUri = uriSubfield.uriTemplate.replace('{id}', id);
    if (existingUri === derivedUri || existingUri.endsWith("/".concat(id))) {
        return; // already the URI of this identifier (template or picked) — keep it
    }
    setValue(uriPath, derivedUri, { shouldDirty: true });
};
export default fillUriFromIdentifier;
